import { useEffect, useState } from 'react';

import classNames from 'classnames';
import Icon, { IconProps } from '../../Atoms/Icon';
import {
  ColorProps,
  getColorClass,
  FontProps,
  getFontClass,
  TextSizeProps,
  getTextSizeClass,
  WeightProps,
  getFontWeightClass
} from '../../../constants/typography';

interface Props {
  as?: 'ul' | 'ol';
  listItems: (string | JSX.Element)[];
  icon?: IconProps;
  size?: TextSizeProps;
  color?: ColorProps;
  font?: FontProps;
  weight?: WeightProps;
  iconClass?: string;
  itemClass?: string;
  className?: string;
  animateMobile?: boolean;
}

function List({
  as: Tag = 'ul',
  listItems,
  icon,
  size = 'sm',
  color = 'white',
  font = 'camphor',
  weight = 400,
  iconClass,
  itemClass,
  className,
  animateMobile = false
}: Props) {
  const timerDuration = 2;
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveStep(
        (prevActiveStep) =>
          (prevActiveStep + 1) % listItems.length
      );
    }, timerDuration * 1000);

    return () => clearInterval(intervalId);
  }, [listItems.length, timerDuration]);
  return (
    <Tag
      className={classNames([
        'relative flex flex-col gap-y-2 pl-7',
        { 'list-decimal': Tag === 'ol' },
        { 'list-disc': !icon && Tag === 'ul' },
        getColorClass(color),
        getFontClass(font),
        getTextSizeClass(size),
        getFontWeightClass(weight),
        className
      ])}
    >
      {listItems.map((item) => (
        <li
          key={listItems.indexOf(item)}
          className={classNames([
            !animateMobile && 'relative opacity-100',
            animateMobile &&
              'absolute top-1/2 -translate-y-1/2 duration-300 first:relative lg:relative lg:flex lg:translate-y-0 lg:opacity-100',
            animateMobile && [
              listItems.indexOf(item) === activeStep
                ? '-translate-y-1/2 opacity-100 first:translate-y-0'
                : 'translate-y-1/2 opacity-0'
            ],
            itemClass
          ])}
        >
          {icon && Tag === 'ul' && (
            <Icon
              className={classNames([
                'absolute left-[-25px] top-[2px] select-none text-sl-yellow md:top-[4px]',
                iconClass
              ])}
              icon={icon}
            />
          )}
          {item}
        </li>
      ))}
    </Tag>
  );
}

export default List;
